// extracted by mini-css-extract-plugin
export default {"container":"styles_container__RGx+X","cell":"styles_cell__S8I8R","link":"styles_link__dhUet","header":"styles_header__f1TB6","bottom":"styles_bottom__DJe-5"};